export const API_URL = "http://5.61.24.163:8000";
//export const API_URL = "http://localhost:8000";

 

